import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { decodeToken, getApiCall } from "../utils/api";
import { Bar, Line, Pie, Doughnut, Radar, PolarArea } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchData();
  }, []);

  const [loggedUser, setLoggedUser] = useState({});
  const [studentAnalytics, setStudentAnalytics] = useState(null);
  const [schoolAnalytics, setSchoolAnalytics] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    const resData = await decodeToken();
    setLoggedUser(resData.user);
    const res = await getApiCall("dashboard/get-counts");
    setData(res.data);
    setLoading(false);

    const studentRes = await getApiCall("student-analytics");
    const schoolRes = await getApiCall("school-analytics");

    setStudentAnalytics(studentRes.data);
    setSchoolAnalytics(schoolRes.data);
  };

  return (
    <div>
      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Dashboard</h4>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 col-6">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{data.length == 0 ? "0" : data[0].totalStudent}</h3>
                    <p>Total Students</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-person-add" />
                  </div>
                  <Link to="/students" className="small-box-footer">
                    More info <i className="fas fa-arrow-circle-right" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-3 col-6">
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>{data.length == 0 ? "0" : data[0].totalSchool}</h3>
                    <p>Total School</p>
                  </div>
                  <div className="icon">
                    <i className="fas fa-school" />
                  </div>
                  <Link to="/schools" className="small-box-footer">
                    More info <i className="fas fa-arrow-circle-right" />
                  </Link>
                </div>
              </div>
              {loggedUser.role == "admin" && (
                <>
                  <div className="col-lg-3 col-6">
                    <div className="small-box bg-success">
                      <div className="inner">
                        <h3>{data.length == 0 ? "0" : data[0].totalModules}</h3>
                        <p>Total Modules/Courses</p>
                      </div>
                      <div className="icon">
                        <i className="ion ion-stats-bars" />
                      </div>
                      <Link to="/modules" className="small-box-footer">
                        More info <i className="fas fa-arrow-circle-right" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-3 col-6">
                    <div className="small-box bg-success">
                      <div className="inner">
                        <h3>{data.length == 0 ? "0" : data[0].olympiadStudents}</h3>
                        <p>Register for Olympiad</p>
                      </div>
                      <div className="icon">
                        <i className="ion ion-stats-bars" />
                      </div>
                      <Link to="/#" className="small-box-footer">
                        More info <i className="fas fa-arrow-circle-right" />
                      </Link>
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* <section className="content">
              <div className="row">
                <div className="col-lg-8">
                  <BarChart
                    barData={data.length == 0 ? data : data[0].barSale}
                  />
                </div>
              </div>
            </section>
            <section className="content">
              <div className="row">
                <div className="col-lg-8">
                  <LineChart
                    lineData={data.length == 0 ? data : data[0].lineUser}
                  />
                </div>
                <div className="col-lg-4">
                  <PieChart
                    boughtPercentage={
                      data.length == 0 ? data : data[0].boughtPercentage
                    }
                    notBoughtPercentage={
                      data.length == 0 ? data : data[0].notBoughtPercentage
                    }
                  />
                </div>
              </div>
            </section>
            <section className="content">
              <div className="row">
                <div className="col-lg-12">
                  <DashBoardTable
                    userData={data.length == 0 ? data : data[0].userTable}
                  />
                </div>
              </div>
            </section> */}

            {/* Global Analytics Charts */}
            <section className="content p-2">
              <div className="row">
                {/* === School Charts === */}
                <div className="row">
                  {/* 1. Students per School */}
                  <div className="col-lg-6 mb-4">
                    <h5>Students per School</h5>
                    {schoolAnalytics?.studentCountPerSchool?.length > 0 ? (
                      <Line
                        data={{
                          labels: schoolAnalytics.studentCountPerSchool.map(
                            (s) => s.school_name
                          ),
                          datasets: [
                            {
                              label: "# of Students",
                              data: schoolAnalytics.studentCountPerSchool.map(
                                (s) => parseInt(s.total_students || 0)
                              ),
                              backgroundColor: "rgba(75, 192, 192, 0.4)",
                              borderColor: "rgba(75, 192, 192, 1)",
                              borderWidth: 2,
                              fill: true, // Optional: fill area under the line
                              tension: 0.3, // Smooth curves
                            },
                          ],
                        }}
                        options={{
                          responsive: true,
                          plugins: {
                            legend: { display: true },
                          },
                          scales: {
                            y: {
                              beginAtZero: true,
                              ticks: {
                                precision: 0, // So that Y-axis doesn't show decimals
                              },
                            },
                          },
                        }}
                      />
                    ) : (
                      <p>No data available</p>
                    )}
                  </div>

                  {/* 2. Top Schools by Progress */}
                  <div className="col-lg-6 mb-4">
                    <h5>Top 5 Schools by Average Progress</h5>
                    {schoolAnalytics?.topSchoolsByProgress?.length > 0 ? (
                      <div
                        style={{
                          width: "300px",
                          height: "300px",
                          margin: "0 auto",
                        }}
                      >
                        <PolarArea
                          data={{
                            labels: schoolAnalytics.topSchoolsByProgress.map(
                              (s) => s.school_name
                            ),
                            datasets: [
                              {
                                label: "Average Progress",
                                data: schoolAnalytics.topSchoolsByProgress.map(
                                  (s) => parseFloat(s.avg_progress || 0)
                                ),
                                backgroundColor: [
                                  "rgba(153, 102, 255, 0.6)",
                                  "rgba(255, 159, 64, 0.6)",
                                  "rgba(54, 162, 235, 0.6)",
                                  "rgba(75, 192, 192, 0.6)",
                                  "rgba(255, 206, 86, 0.6)",
                                ],
                                borderWidth: 1,
                              },
                            ],
                          }}
                          options={{
                            responsive: true,
                            maintainAspectRatio: true,
                            plugins: {
                              legend: {
                                position: "top", // 🔄 change from 'right' to 'top'
                              },
                              tooltip: {
                                callbacks: {
                                  label: (context) =>
                                    `${context.label}: ${context.formattedValue}%`,
                                },
                              },
                            },
                            scales: {
                              r: {
                                beginAtZero: true,
                                max: 100,
                                ticks: {
                                  stepSize: 20,
                                },
                              },
                            },
                          }}
                        />
                      </div>
                    ) : (
                      <p>No data available</p>
                    )}
                  </div>

                  {/* 3. Active vs Inactive Schools (Pie Chart) */}
                  <div className="col-lg-6 mb-4">
                    <h5>Active vs Inactive Schools</h5>
                    {schoolAnalytics?.totalSchools > 0 ? (
                      <div style={{ maxWidth: "300px", margin: "0 auto" }}>
                        <Pie
                          data={{
                            labels: ["Active", "Inactive"],
                            datasets: [
                              {
                                label: "Schools",
                                data: [
                                  schoolAnalytics.activeSchoolCount,
                                  schoolAnalytics.totalSchools -
                                    schoolAnalytics.activeSchoolCount,
                                ],
                                backgroundColor: ["#36A2EB", "#FF6384"],
                              },
                            ],
                          }}
                          width={300}
                          height={300}
                          options={{
                            maintainAspectRatio: false,
                            plugins: {
                              legend: {
                                position: "bottom",
                              },
                            },
                          }}
                        />
                      </div>
                    ) : (
                      <p>No data available</p>
                    )}
                  </div>

                  {/* 4. Total Schools (Single Value Bar) */}
                  <div className="col-lg-6 mb-4">
                    <h5>Total Schools Overview</h5>
                    {schoolAnalytics?.totalSchools !== undefined ? (
                      <Bar
                        data={{
                          labels: ["Total", "Active", "Inactive"],
                          datasets: [
                            {
                              label: "Schools",
                              data: [
                                schoolAnalytics.totalSchools,
                                schoolAnalytics.activeSchoolCount,
                                schoolAnalytics.totalSchools -
                                  schoolAnalytics.activeSchoolCount,
                              ],
                              backgroundColor: [
                                "rgba(54, 162, 235, 0.6)",
                                "rgba(75, 192, 192, 0.6)",
                                "rgba(255, 99, 132, 0.6)",
                              ],
                            },
                          ],
                        }}
                        options={{
                          responsive: true,
                          plugins: {
                            legend: { display: false },
                          },
                        }}
                      />
                    ) : (
                      <p>No data available</p>
                    )}
                  </div>
                </div>

                {/* === Student Charts === */}
                <div className="col-lg-6 mt-4">
                  <h5>Student Progress Distribution</h5>
                  {studentAnalytics?.milestoneStats ? (
                    <div style={{ width: "100%", height: "300px" }}>
                      <Radar
                        data={{
                          labels: ["25%", "50%", "75%", "100%"],
                          datasets: [
                            {
                              label: "# of Students",
                              data: [
                                parseInt(
                                  studentAnalytics.milestoneStats
                                    .milestone_25 || 0
                                ),
                                parseInt(
                                  studentAnalytics.milestoneStats
                                    .milestone_50 || 0
                                ),
                                parseInt(
                                  studentAnalytics.milestoneStats
                                    .milestone_75 || 0
                                ),
                                parseInt(
                                  studentAnalytics.milestoneStats
                                    .milestone_100 || 0
                                ),
                              ],
                              backgroundColor: "rgba(255, 206, 86, 0.4)",
                              borderColor: "rgba(255, 206, 86, 1)",
                              pointBackgroundColor: "rgba(255, 159, 64, 1)",
                              borderWidth: 2,
                            },
                          ],
                        }}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false, // allows the height to take effect
                          plugins: {
                            legend: { position: "top" },
                          },
                          scales: {
                            r: {
                              ticks: {
                                beginAtZero: true,
                                precision: 0,
                              },
                            },
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </div>

                <div className="col-lg-6 mt-4">
                  <h5>Top 5 Students by Progress</h5>
                  {studentAnalytics?.topStudents?.length > 0 ? (
                    <Bar
                      data={{
                        labels: studentAnalytics.topStudents.map(
                          (s) => `${s.name} (${s.school_name})`
                        ),
                        datasets: [
                          {
                            label: "Average Progress",
                            data: studentAnalytics.topStudents.map((s) =>
                              parseFloat(s.avg_progress)
                            ),
                            backgroundColor: "rgba(255, 99, 132, 0.5)",
                            borderColor: "rgba(255, 99, 132, 1)",
                            borderWidth: 1,
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        indexAxis: "y", // 🔄 horizontal bars
                        plugins: {
                          legend: {
                            display: false,
                          },
                          tooltip: {
                            callbacks: {
                              label: (context) =>
                                `${context.dataset.label}: ${context.formattedValue}%`,
                            },
                          },
                        },
                        scales: {
                          x: {
                            beginAtZero: true,
                            max: 100,
                            ticks: {
                              stepSize: 20,
                            },
                          },
                        },
                      }}
                    />
                  ) : (
                    <p>No data</p>
                  )}
                </div>

                <div className="col-lg-6 mt-4">
                  <h5>Total Active vs Inactive Students</h5>
                  {studentAnalytics?.totalActiveStudents !== undefined ? (
                    <div
                      style={{
                        width: "300px",
                        height: "300px",
                        margin: "0 auto",
                      }}
                    >
                      <Doughnut
                        data={{
                          labels: ["Active", "Inactive"],
                          datasets: [
                            {
                              data: [
                                studentAnalytics.totalActiveStudents,
                                (studentAnalytics.totalStudents || 0) -
                                  studentAnalytics.totalActiveStudents,
                              ],
                              backgroundColor: ["#4BC0C0", "#FF9F40"],
                            },
                          ],
                        }}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                        }}
                      />
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </div>

                <div className="col-lg-6 mt-4">
                  <h5>Average Student Progress</h5>
                  {studentAnalytics?.averageProgress !== undefined ? (
                    <Bar
                      data={{
                        labels: ["Average Progress"],
                        datasets: [
                          {
                            label: "Progress %",
                            data: [studentAnalytics.averageProgress],
                            backgroundColor: "rgba(54, 162, 235, 0.5)",
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        scales: {
                          y: {
                            beginAtZero: true,
                            max: 100,
                          },
                        },
                      }}
                    />
                  ) : (
                    <p>No data</p>
                  )}
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Dashboard;
